import { Component } from '@angular/core';
import { EventService } from '../../../services';
import { OrganisationSelectorEventTypeEnum } from '../../../interfaces/telephony/organisation-selector-event-type.enum';
import { IOrganisationSelectorEvent } from '../../../interfaces/telephony/organisation-selector-event';
import { IBasicOrganisationInfo } from '../../../interfaces/telephony/basic-organisation-info';
import { IBasicUser } from '../../../interfaces/telephony/basic-user.dto.interface';

@Component({
  selector: 'add-number-select-user-org',
  templateUrl: './add-number-select-user-org.component.html',
  styleUrls: ['./add-number-to-organisation.component.scss'],
})
export class AddNumberSelectUserOrgComponent {
  constructor(private eventService: EventService) {
    this.eventService.OrganisationSelectorEvent.subscribe((event: IOrganisationSelectorEvent) => {
      if (event.eventType == OrganisationSelectorEventTypeEnum.OpenUserSelector) {
        this.selectorVisible = true;
        this.organisation = event.args.selectedOrg;
        this.filteredUsers = this.organisation.users;
      }
      if (
        event.eventType == OrganisationSelectorEventTypeEnum.AddNumberSelectorClosed ||
        event.eventType == OrganisationSelectorEventTypeEnum.CloseUserSelector
      ) {
        this.selectorVisible = false;
      }
    });
  }

  organisation: IBasicOrganisationInfo;
  selectorVisible = false;

  filteredUsers: IBasicUser[];
  searchText: any;

  selectedUser: IBasicUser;

  searchTextChanged(text) {
    text = text || '';

    let search = text.toLowerCase().trim();
    this.searchText = search;

    // filter the current results by name when 2 chars or more
    if (search && search.length >= 2) {
      this.filterResults();
    }
  }

  filterResults() {
    this.filteredUsers = this.organisation.users.filter(
      (x) => x.name && x.name.toLowerCase().indexOf(this.searchText) >= 0,
    );
  }

  orgSelected() {
    this.selectedUser = null;
  }

  userSelected(user: IBasicUser) {
    this.selectedUser = user;
  }

  confirmSelection() {
    if (!this.selectedUser && !this.organisation) {
      return;
    }

    if (this.selectedUser) {
      this.eventService.OrganisationSelectorEvent.emit({
        eventType: OrganisationSelectorEventTypeEnum.AssociateUserSelected,
        args: {
          selectedOrg: this.organisation,
          selectedUser: this.selectedUser,
        },
      });
    } else {
      this.eventService.OrganisationSelectorEvent.emit({
        eventType: OrganisationSelectorEventTypeEnum.AssociateOrganisationSelected,
        args: { selectedOrg: this.organisation, selectedUser: null },
      });
    }

    this.selectorVisible = false;
  }
}
